import {
  isInvalidation, isReprocessing,
  isSatelliteImagery,
} from "./configurationHelper"
import { CircleShapeType, ShapeSearchDataType, ShapeType } from "../types/shape"
import { getCoordinatesFromSelectedArea, isACircleShape } from "./shapeHelper"
import { hasResultsPageLimits } from "./searchResultsHelper"
import { AppParametersType } from "../types/app"

export const FIRST_SEARCH_PAGE_NUMBER = 1
const SEARCH_PAGE_SIZE = 10
const DATA_PROVIDER_SEARCH_PAGE_SIZE = 100

export const getPageSizeSearchDataFrom = (
  appParameters: AppParametersType,
  formData: any,
  formValues: any
): number => {
  return hasResultsPageLimits(appParameters, formValues)
    ? DATA_PROVIDER_SEARCH_PAGE_SIZE
    : (formData && formData.pageSize) || SEARCH_PAGE_SIZE
}

export const getShapeSearchDataFrom = (
  selectedArea: ShapeType
): ShapeSearchDataType => {
  const shapeMap: ShapeSearchDataType = {}
  if (isACircleShape(selectedArea)) {
    const circleShape = selectedArea as CircleShapeType
    shapeMap.circle = {
      radius: circleShape.circle_radius / 1000,
      center: circleShape.circle_center,
    }
  } else {
    shapeMap.polygon = [getCoordinatesFromSelectedArea(selectedArea)]
  }

  return shapeMap
}

export const getMainInputConfigurationsBy = (configurations, appParameters) => {
  let mainInputConfigurations = {}

  if (isSatelliteImagery(configurations, appParameters)) {
    mainInputConfigurations = getSatelliteImageryMainInputsConfigurationsBy(configurations)
  } else if (isInvalidation(configurations, appParameters)) {
    mainInputConfigurations = getInvalidationMainInputsConfigurationsBy(configurations)
  } else if (isReprocessing(configurations, appParameters)) {
    mainInputConfigurations = getReprocessingMainInputsConfigurationsBy(configurations)
  } else {
    console.error("Unhandled Configurations")
  }

  return mainInputConfigurations
}

const getSatelliteImageryMainInputsConfigurationsBy = (configurations) => ({
  routine: {
    name: "routine",
    description: "Routine",
    type: "boolean",
    default: true,
  },
  search_mode: {
    name: "search_mode",
    description: "search_mode",
    type: "boolean",
    default: false,
  },
  date1: {
    name: "date1",
    description: "From date",
    type: "string",
    default: "",
    required: false,
  },
  date2: {
    name: "date2",
    description: "To date",
    type: "string",
    default: "",
    required: false,
  },
  typeInput: {
    name: "typeInput",
    description: "Product name",
    type: "string",
    default: configurations.productName,
  },
  missions: {
    name: "missions",
    description: "Missions",
    type: "object",
    default: [],
    minLength: 1,
    required: true,
  },
})

const getInvalidationMainInputsConfigurationsBy = (configurations) => ({
  invalidate_mode: {
    name: "invalidate_mode",
    description: "Validate/Invalidate",
    type: "boolean",
    default: false,
  },
  routine: {
    name: "routine",
    description: "Routine",
    type: "boolean",
    default: true,
  },
  date1: {
    name: "date1",
    description: "From date",
    type: "string",
    default: "",
    required: false,
  },
  date2: {
    name: "date2",
    description: "To date",
    type: "string",
    default: "",
    required: false,
  },
  missions: {
    name: "missions",
    description: "Missions",
    type: "object",
    default: ["026" , "027"],
    minLength: 1,
    required: true,
  },
})

const getReprocessingMainInputsConfigurationsBy = (configurations) => ({
  routine: {
    name: "routine",
    description: "Routine",
    type: "boolean",
    default: false,
  },
  date1: {
    name: "date1",
    description: "From date",
    type: "string",
    default: "",
    required: false,
  },
  date2: {
    name: "date2",
    description: "To date",
    type: "string",
    default: "",
    required: false,
  },
  missions: {
    name: "missions",
    description: "Missions",
    type: "object",
    default: ["026" , "027"],
    minLength: 1,
    required: true,
  },
})
